<template>
    <div class="select-address position-relative">
        <div v-if="loading" class="loader d-flex align-items-center text-center justify-content-center">
            <div class="spinner-border" role="status" aria-hidden="true"></div>
        </div>
        <div class="row">
            <div v-if="addresses" class="col-12 col-lg-9">
                <div class="styled-dropdown mb-3 mb-lg-0">
                    <select class="form-control mb-2" v-if="addresses" v-model="selectedAddressId" :id="addressIdentifier + '-select'">
                        <option disabled selected v-if="addresses.length < 1">No addresses found - Please add an address.</option>
                        <option
                        v-for="address in addresses"
                        v-bind:key="address.id"
                        v-bind:value="address.id"
                        :selected="address.id == selectedAddressId"
                        >
                        {{ address.summary }}
                        </option>
                    </select>
                    <i class="fas fa-chevron-down"></i>
                </div>
            </div>
            <div class="col-12 col-lg-3 d-flex flex-lg-column justify-content-lg-end justify-content-between  align-items-end">
                <a href="#" v-on:click="editAddress" data-toggle="modal" target="#edit-address-modal" v-if="addresses.length > 0">
                    Edit Address <i class="fal fa-pencil"></i>
                </a>
                <a href="#" v-on:click="addAddress" data-toggle="modal" target="#add-address-modal">
                    Add Address <i class="far fa-plus"></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            selectedAddressId: null,
            addresses: [],
        };
    },

    props: [
        'addressIdentifier',
        'addressLabel'
    ],

    watch: {
        loading: function (val) {
            document.querySelector("button#continue").disabled = val;
        },
        selectedAddressId: function (addressId) {
            if (this.addressIdentifier == 'delivery_address_id') {
                this.$root.$emit('deliveryAddressSelected', addressId);
            }
            document.getElementById(this.addressIdentifier).value = addressId;
            document.getElementById(this.addressIdentifier + '-select').val = this.addressId;
        }
    },

    mounted() {
        this.$root.$on('addressAdded', this.getAddresses);
        this.$root.$on('addressUpdated', this.getAddresses);
        this.$root.$on('addressUpdated', this.refreshShippingMethods);
        this.selectedAddressId = document.getElementById(this.addressIdentifier).value;
        this.getAddresses();
    },

    methods: {
        editAddress() {
            this.$root.$emit('addressEdit', this.selectedAddressId);
            $('#edit-address-modal').modal('show');
        },
        addAddress() {
            this.$root.$emit('addressAdd', this.addressIdentifier, this.selectedAddressId);
            $('#add-address-modal').modal('show');
        },
        getAddresses(newAddressId = null, targetAddressIdentIfier = null) {
            axios.get('/api/v1/address/get')
                .then(res => {
                    if (res.data && res.data.success) {
                        this.addresses = res.data.addresses;
                        if (!this.selectedAddressId && !newAddressId && res.data.primary_address_id) {
                            this.selectedAddressId = res.data.primary_address_id;
                        } else if (newAddressId &&
                            (targetAddressIdentIfier == this.addressIdentifier || this.addresses.length == 1)
                        ) {
                            this.selectedAddressId = newAddressId;
                        } else if (this.selectedAddressId) {
                            document.getElementById(this.addressIdentifier + '-select').this.selectedAddressId.value;
                        }
                    }
                })
                .catch(error => {
                    //
                })
                .finally(res => {
                    this.loading = false;
                });
        },
        refreshShippingMethods() {
            if (this.addressIdentifier == 'delivery_address_id') {
                this.$root.$emit('deliveryAddressSelected', this.selectedAddressId);
            }
        }
    }
};
</script>
